import { AlertDialog } from '../../Components/AlertDialog';
import { DialogState } from './copyTigerUtils';

interface CopyTigerAlertProps {
  dialog: DialogState | undefined;
  isLoading: boolean;
  onHide: () => void;
}

export const CopyTigerAlert = ({ dialog, isLoading, onHide }: CopyTigerAlertProps) => {
  if (isLoading || !dialog) return null;
  return (
    <AlertDialog
      body={dialog.body}
      icon={undefined}
      onHide={onHide}
      primaryAction={{ onClick: dialog.onConfirm, label: dialog.onConfirm ? 'Delete' : undefined }}
      secondaryAction={{ onClick: dialog.onConfirm ? onHide : undefined }}
      show
      title={dialog.title}
      intent={dialog.intent}
    />
  );
};
